import { useSyncExternalStore } from 'react'

import { hasAccepted } from './hasCookieConsent'
import { SKIP_COOKIE_CONSENT } from './skipCookieConsent'

// One latch per category; the `undefined` key is the no-argument call.
const grantedInSession = new Map<string | undefined, boolean>([
  [undefined, hasAccepted()]
])

const isGranted = (category?: string) => {
  if (!grantedInSession.has(category)) {
    grantedInSession.set(category, hasAccepted(category))
  }
  return grantedInSession.get(category) === true
}

const useCookieConsent = (category?: string) => {
  return useSyncExternalStore(
    callback => {
      const handleCurrentState = () => {
        grantedInSession.forEach((granted, key) => {
          if (!granted && hasAccepted(key)) {
            grantedInSession.set(key, true)
          }
        })
        callback()
      }
      window.addEventListener('CookieScriptCurrentState', handleCurrentState)
      return () =>
        window.removeEventListener(
          'CookieScriptCurrentState',
          handleCurrentState
        )
    },
    () => SKIP_COOKIE_CONSENT || isGranted(category),
    () => false
  )
}

export { useCookieConsent }
